import {
  BpkTable,
  BpkTableBody,
} from '@skyscanner/backpack-web/bpk-component-table';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import Snippet from './Snippet';

import type { SnippetProps } from './Snippet/Snippet';
import type { HotelPolicy, HotelTime } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './FastFacts.module.scss';

import SectionHeader from '@hotels-hotel-detail/ui/SectionHeader';
import { withI18n } from '@shared/ui/contexts/i18n';
import {
  getBreakfastPolicy,
  getPetsPolicy,
  getChildrenPolicy,
} from '@shared/utils-universal/fast-facts';

const cls = cssModules(STYLES);

export type FastFactsProps = {
  checkinTime?: HotelTime;
  checkoutTime?: HotelTime;
  i18n: I18nService;
  hotelPolicies?: HotelPolicy[];
};

const FastFacts = ({
  checkinTime,
  checkoutTime,
  hotelPolicies,
  i18n,
}: FastFactsProps) => {
  const snippets: SnippetProps[] = [];

  if (checkinTime) {
    snippets.push({
      icon: 'time',
      label: checkinTime.title,
      value: checkinTime.time,
    });
  }

  if (checkoutTime) {
    snippets.push({
      icon: 'time',
      label: checkoutTime.title,
      value: checkoutTime.time,
    });
  }

  const breakfastPolicy = getBreakfastPolicy(hotelPolicies);
  if (breakfastPolicy && breakfastPolicy.breakfastPolicyDetails) {
    snippets.push({
      icon: 'cafe',
      label: breakfastPolicy.displayName,
      value: breakfastPolicy.breakfastPolicyDetails.title,
    });
  }
  const petsPolicy = getPetsPolicy(hotelPolicies);
  if (petsPolicy) {
    snippets.push({
      icon: 'hotelsPetsAllowed',
      label: petsPolicy.displayName,
      value: petsPolicy.textPolicyDetails,
    });
  }
  const childrenPolicy = getChildrenPolicy(hotelPolicies);
  if (childrenPolicy) {
    snippets.push({
      icon: 'family',
      label: childrenPolicy.displayName,
      value: childrenPolicy.textPolicyDetails,
    });
  }

  if (!snippets?.length) {
    return null;
  }

  return (
    <div className={cls('FastFacts')}>
      <SectionHeader title={i18n.translate('FastFacts_HDP_heading')} />
      <BpkTable className={cls('FastFacts__snippets')}>
        <BpkTableBody className={cls('FastFacts__snippets--wrap')}>
          {snippets.map((snippet) => (
            <Snippet key={snippet.label} {...snippet} />
          ))}
        </BpkTableBody>
      </BpkTable>
    </div>
  );
};

export default withI18n(FastFacts);
